import { render, staticRenderFns } from "./setting-exchange-repair.vue?vue&type=template&id=272ce4af"
import script from "./setting-exchange-repair.vue?vue&type=script&lang=js"
export * from "./setting-exchange-repair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports